function shortValues(value) {
    if (value === null || value === undefined || Number.isNaN(value)) return '';

    const absVal = Math.abs(value);

    if (absVal >= 1.0e+12) {
        return `${(value / 1.0e+12).toFixed(1).replace(/\.0$/, '')}T`;
    } if (absVal >= 1.0e+9) {
        return `${(value / 1.0e+9).toFixed(1).replace(/\.0$/, '')}B`;
    } if (absVal >= 1.0e+6) {
        return `${(value / 1.0e+6).toFixed(1).replace(/\.0$/, '')}M`;
    } if (absVal >= 1.0e+3) {
        return `${(value / 1.0e+3).toFixed(1).replace(/\.0$/, '')}K`;
    } if (absVal > 0 && absVal < 0.01) {
        const exp = Math.floor(Math.log10(absVal));
        const base = (value / Math.pow(10, exp)).toFixed(1).replace(/\.0$/, '');
        return `${base}e${exp}`;
    }

    return value.toFixed(2).replace(/\.0+$/, '');
}

export default shortValues;
